import React, { Component } from "react";
import Table from "./components/Table";

class TablesEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: props.columns,
      data: props.data,
      title: props.title,
    };
  }

  componentDidMount = () => {
    this.setState({
      columns: this.props.columns,
      data: this.props.data,
      title: this.props.title,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      columns: nextProps.columns,
      data: nextProps.data,
      title: nextProps.title,
    });
  };

  render() {
    const { columns, data } = this.state;
    return (
      <Table
        columns={columns}
        data={data}
        options={{
          large: true,
          downloads: {
            pdf: false,
            xlsx: false,
          },
        }}
      />
    );
  }
}

export default TablesEvent;
